import log from 'loglevel';

export const configureLogging = () => {
  log.setDefaultLevel('INFO');
};
